/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BulkOperationResultDto } from '../models/bulk-operation-result-dto';
import { DocumentOperationResponseDto } from '../models/document-operation-response-dto';
import { documentsControllerBulkCreateDocuments } from '../fn/documents/documents-controller-bulk-create-documents';
import { DocumentsControllerBulkCreateDocuments$Params } from '../fn/documents/documents-controller-bulk-create-documents';
import { documentsControllerCreateDocument } from '../fn/documents/documents-controller-create-document';
import { DocumentsControllerCreateDocument$Params } from '../fn/documents/documents-controller-create-document';
import { documentsControllerDeleteDocument } from '../fn/documents/documents-controller-delete-document';
import { DocumentsControllerDeleteDocument$Params } from '../fn/documents/documents-controller-delete-document';
import { documentsControllerFilterDocuments } from '../fn/documents/documents-controller-filter-documents';
import { DocumentsControllerFilterDocuments$Params } from '../fn/documents/documents-controller-filter-documents';
import { documentsControllerGetDocument } from '../fn/documents/documents-controller-get-document';
import { DocumentsControllerGetDocument$Params } from '../fn/documents/documents-controller-get-document';
import { documentsControllerGetDocumentStats } from '../fn/documents/documents-controller-get-document-stats';
import { DocumentsControllerGetDocumentStats$Params } from '../fn/documents/documents-controller-get-document-stats';
import { documentsControllerHandleS3Event } from '../fn/documents/documents-controller-handle-s-3-event';
import { DocumentsControllerHandleS3Event$Params } from '../fn/documents/documents-controller-handle-s-3-event';
import { documentsControllerHealthCheck } from '../fn/documents/documents-controller-health-check';
import { DocumentsControllerHealthCheck$Params } from '../fn/documents/documents-controller-health-check';
import { documentsControllerLogDownload } from '../fn/documents/documents-controller-log-download';
import { DocumentsControllerLogDownload$Params } from '../fn/documents/documents-controller-log-download';
import { documentsControllerUpdateDocument } from '../fn/documents/documents-controller-update-document';
import { DocumentsControllerUpdateDocument$Params } from '../fn/documents/documents-controller-update-document';
import { DocumentStatsResponseDto } from '../models/document-stats-response-dto';
import { ResponseDocumentDto } from '../models/response-document-dto';

@Injectable({ providedIn: 'root' })
export class DocumentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsControllerCreateDocument()` */
  static readonly DocumentsControllerCreateDocumentPath = '/thalea-documents/documents';

  /**
   * Create a new patient document.
   *
   * Creates a new medical document for a patient with metadata and S3 reference
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerCreateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerCreateDocument$Response(params: DocumentsControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDocumentDto>> {
    return documentsControllerCreateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new patient document.
   *
   * Creates a new medical document for a patient with metadata and S3 reference
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerCreateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerCreateDocument(params: DocumentsControllerCreateDocument$Params, context?: HttpContext): Observable<ResponseDocumentDto> {
    return this.documentsControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDocumentDto>): ResponseDocumentDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerBulkCreateDocuments()` */
  static readonly DocumentsControllerBulkCreateDocumentsPath = '/thalea-documents/documents/bulk';

  /**
   * Create multiple documents in bulk.
   *
   * Creates multiple patient documents in a single operation with error handling
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerBulkCreateDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerBulkCreateDocuments$Response(params: DocumentsControllerBulkCreateDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkOperationResultDto>> {
    return documentsControllerBulkCreateDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Create multiple documents in bulk.
   *
   * Creates multiple patient documents in a single operation with error handling
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerBulkCreateDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerBulkCreateDocuments(params: DocumentsControllerBulkCreateDocuments$Params, context?: HttpContext): Observable<BulkOperationResultDto> {
    return this.documentsControllerBulkCreateDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkOperationResultDto>): BulkOperationResultDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerHandleS3Event()` */
  static readonly DocumentsControllerHandleS3EventPath = '/thalea-documents/documents/s3-event';

  /**
   * Process S3 event for automatic document registration.
   *
   * Automatically registers documents when they are uploaded to S3 based on bucket events
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerHandleS3Event()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerHandleS3Event$Response(params: DocumentsControllerHandleS3Event$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentOperationResponseDto>> {
    return documentsControllerHandleS3Event(this.http, this.rootUrl, params, context);
  }

  /**
   * Process S3 event for automatic document registration.
   *
   * Automatically registers documents when they are uploaded to S3 based on bucket events
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerHandleS3Event$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerHandleS3Event(params: DocumentsControllerHandleS3Event$Params, context?: HttpContext): Observable<DocumentOperationResponseDto> {
    return this.documentsControllerHandleS3Event$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentOperationResponseDto>): DocumentOperationResponseDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerFilterDocuments()` */
  static readonly DocumentsControllerFilterDocumentsPath = '/thalea-documents/documents/filter';

  /**
   * Filter and search documents.
   *
   * Filter documents using DynamoDB indexes (tenant, patientId, status)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerFilterDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerFilterDocuments$Response(params: DocumentsControllerFilterDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseDocumentDto>>> {
    return documentsControllerFilterDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter and search documents.
   *
   * Filter documents using DynamoDB indexes (tenant, patientId, status)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerFilterDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerFilterDocuments(params: DocumentsControllerFilterDocuments$Params, context?: HttpContext): Observable<Array<ResponseDocumentDto>> {
    return this.documentsControllerFilterDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseDocumentDto>>): Array<ResponseDocumentDto> => r.body)
    );
  }

  /** Path part for operation `documentsControllerGetDocumentStats()` */
  static readonly DocumentsControllerGetDocumentStatsPath = '/thalea-documents/documents/stats';

  /**
   * Get document statistics.
   *
   * Retrieves various statistics about documents including counts, sizes, and distributions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerGetDocumentStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerGetDocumentStats$Response(params: DocumentsControllerGetDocumentStats$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentStatsResponseDto>> {
    return documentsControllerGetDocumentStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get document statistics.
   *
   * Retrieves various statistics about documents including counts, sizes, and distributions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerGetDocumentStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerGetDocumentStats(params: DocumentsControllerGetDocumentStats$Params, context?: HttpContext): Observable<DocumentStatsResponseDto> {
    return this.documentsControllerGetDocumentStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentStatsResponseDto>): DocumentStatsResponseDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerGetDocument()` */
  static readonly DocumentsControllerGetDocumentPath = '/thalea-documents/documents/{tenant}/{documentId}';

  /**
   * Get document by ID.
   *
   * Retrieves a specific document by its unique identifier
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerGetDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerGetDocument$Response(params: DocumentsControllerGetDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDocumentDto>> {
    return documentsControllerGetDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Get document by ID.
   *
   * Retrieves a specific document by its unique identifier
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerGetDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerGetDocument(params: DocumentsControllerGetDocument$Params, context?: HttpContext): Observable<ResponseDocumentDto> {
    return this.documentsControllerGetDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDocumentDto>): ResponseDocumentDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerUpdateDocument()` */
  static readonly DocumentsControllerUpdateDocumentPath = '/thalea-documents/documents/{tenant}/{documentId}';

  /**
   * Update document metadata.
   *
   * Updates document metadata such as title, description, tags, and other properties
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerUpdateDocument$Response(params: DocumentsControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDocumentDto>> {
    return documentsControllerUpdateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Update document metadata.
   *
   * Updates document metadata such as title, description, tags, and other properties
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerUpdateDocument(params: DocumentsControllerUpdateDocument$Params, context?: HttpContext): Observable<ResponseDocumentDto> {
    return this.documentsControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseDocumentDto>): ResponseDocumentDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerDeleteDocument()` */
  static readonly DocumentsControllerDeleteDocumentPath = '/thalea-documents/documents/{tenant}/{documentId}';

  /**
   * Delete document.
   *
   * Soft deletes a document and optionally removes the S3 file
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerDeleteDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerDeleteDocument$Response(params: DocumentsControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentOperationResponseDto>> {
    return documentsControllerDeleteDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete document.
   *
   * Soft deletes a document and optionally removes the S3 file
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerDeleteDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerDeleteDocument(params: DocumentsControllerDeleteDocument$Params, context?: HttpContext): Observable<DocumentOperationResponseDto> {
    return this.documentsControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentOperationResponseDto>): DocumentOperationResponseDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerLogDownload()` */
  static readonly DocumentsControllerLogDownloadPath = '/thalea-documents/documents/{tenant}/{documentId}/download-log';

  /**
   * Log document download access.
   *
   * Logs when a document is downloaded directly from S3 by frontend
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerLogDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerLogDownload$Response(params: DocumentsControllerLogDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentOperationResponseDto>> {
    return documentsControllerLogDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * Log document download access.
   *
   * Logs when a document is downloaded directly from S3 by frontend
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerLogDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsControllerLogDownload(params: DocumentsControllerLogDownload$Params, context?: HttpContext): Observable<DocumentOperationResponseDto> {
    return this.documentsControllerLogDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentOperationResponseDto>): DocumentOperationResponseDto => r.body)
    );
  }

  /** Path part for operation `documentsControllerHealthCheck()` */
  static readonly DocumentsControllerHealthCheckPath = '/thalea-documents/documents/health';

  /**
   * Health check.
   *
   * Check if the documents service is healthy and operational
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsControllerHealthCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerHealthCheck$Response(params?: DocumentsControllerHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'status'?: string;
'timestamp'?: number;
'service'?: string;
}>> {
    return documentsControllerHealthCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * Health check.
   *
   * Check if the documents service is healthy and operational
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsControllerHealthCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsControllerHealthCheck(params?: DocumentsControllerHealthCheck$Params, context?: HttpContext): Observable<{
'status'?: string;
'timestamp'?: number;
'service'?: string;
}> {
    return this.documentsControllerHealthCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'status'?: string;
'timestamp'?: number;
'service'?: string;
}>): {
'status'?: string;
'timestamp'?: number;
'service'?: string;
} => r.body)
    );
  }

}
